export const secondsToHMS = (seconds: number, displaySeconds: boolean = false) => {
    const time = Math.round(seconds);
    if (isNaN(time)) return " - ";
    if (time === 0) return "0s";

    let h = Math.floor(time / 3600);

    let m = displaySeconds
        ? // If seconds are displayed, the minutes are not rounded because
          // the digits after the decimal will be considered in the seconds calculation
          Math.floor((time % 3600) / 60)
        : // else the minutes have to be rounded to keep the info of the decimals
          Math.round((time % 3600) / 60);

    // check if rounding minutes will make hours roll over
    if (m === 60) {
        h = h + 1;
        m = m - 60;
    }

    const s = (time % 3600) % 60;
    const hDisplay = h > 0 ? h.toString() + "h" : "";
    const mDisplay =
        h > 0
            ? m.toLocaleString("fr", {
                  minimumIntegerDigits: 2,
                  useGrouping: false
              })
            : m.toLocaleString("fr", {
                  minimumIntegerDigits: 1,
                  useGrouping: false
              }) + `${h === 0 ? " min" : "min"}`;
    const sDisplay = s > 0 && displaySeconds ? s.toString() + `${m === 0 ? " s" : "s"}` : "";
    const resp = hDisplay + mDisplay + sDisplay;
    if (resp === "") return " - ";
    return resp;
};
